<rt-box variant="padding-small" [style.height]="height ? height + 'px' : ''" layout-vertical>
  <rt-placeloader></rt-placeloader>
  @if (!onlyOnePlaceloader) {
    <rt-placeloader class="short"> </rt-placeloader>
  }
</rt-box>
